//Toggle an item in an array. If the item is already in the array, it will be removed. If the item is not in the array, it will be added.
export function toggleInArray<T>(array: T[] | undefined, item: T): T[] {
  const arr = array || [];
  return arr.includes(item) ? arr.filter((i) => i !== item) : [...arr, item];
}
